import { LOCATIONS } from "@/data/locations";
import { TEAM } from "@/data/team";
import type { TimeSlot, PersonSlot, Location } from "@/types";

export function findSlots(
  ids: (string | number)[],
  durMins: number,
  tentFree: boolean
): TimeSlot[] {
  const members = ids.map((id) => TEAM.find((m) => m.id === id)!).filter(Boolean);
  const step = 0.5;
  const needed = durMins / 30;
  const results: TimeSlot[] = [];

  for (let u = 0; u < 24; u += step) {
    const end = u + needed * step;
    if (end > 24) continue;

    let ok = true;
    let tent = false;
    const perPerson: PersonSlot[] = [];

    for (const m of members) {
      const loc = LOCATIONS[m.location] as Location;
      const localStart = ((u + loc.utc) % 24 + 24) % 24;
      const localEnd = ((end + loc.utc) % 24 + 24) % 24;

      if (localStart < loc.work[0] || localEnd > loc.work[1]) {
        ok = false;
        break;
      }

      for (const ev of m.events) {
        const evStart = ((ev.start - loc.utc) % 24 + 24) % 24;
        const evEnd = ((ev.end - loc.utc) % 24 + 24) % 24;

        if (u < evEnd && end > evStart) {
          if (ev.status === "confirmed") {
            ok = false;
            break;
          }
          if (ev.status === "tentative") {
            if (!tentFree) {
              ok = false;
              break;
            }
            tent = true;
          }
        }
      }

      if (!ok) break;
      perPerson.push({ member: m, localStart, localEnd, loc });
    }

    if (ok) {
      results.push({
        utcStart: u,
        utcEnd: end,
        perPerson,
        hasTentativeOverlap: tent,
      });
    }
  }

  results.sort((a, b) =>
    a.hasTentativeOverlap === b.hasTentativeOverlap ? 0 : a.hasTentativeOverlap ? 1 : -1
  );

  return results;
}

export function formatTime(h: number): string {
  const hr = Math.floor(h);
  const mn = (h % 1) * 60;
  const ap = hr >= 12 ? "PM" : "AM";
  return `${hr === 0 ? 12 : hr > 12 ? hr - 12 : hr}:${mn.toString().padStart(2, "0")} ${ap}`;
}
